module.exports = __webpack_public_path__ + "media/close.8093e54d.wav";